<!-- Ported from the Polaris kit: src/components/ui/message/MessageHeader.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { Primitive } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false, default: 'div' },
});
</script>

<template>
  <Primitive
    data-slot="message-header"
    :as="as"
    :as-child="asChild"
    :class="
      cn(
        'type-polaris-caption font-medium text-polaris-muted-foreground px-3 group-has-[[data-variant=ghost]]/message:px-0 flex max-w-full min-w-0 items-center',
        props.class
      )
    "
  >
    <slot />
  </Primitive>
</template>
